import { combineReducers } from 'redux'
import loadingReducer from './loading.reducer'
import notifyReducer from './notify.reducer'
import alertReducer from './alert.reducer'
import authReducer from './auth.reducer'
import campaignsReducer from './campaigns.reducer'
import linksReducer from './links.reducer'
import navigationReducer from './navigation.reducer'
import appReducer from './app.reducer'
import metricsReducer from './metrics.reducer'
import pixelReducer from './pixel.reducer'
import googleReducer from './google.reducer'
import webhookReducer from './webhooks.reducer'
import smsReducer from './sms.reducer'

const rootReducer = combineReducers({
    loadingReducer,
    notifyReducer,
    alertReducer,
    authReducer,
    campaignsReducer,
    metricsReducer,
    navigationReducer,
    appReducer,
    linksReducer,
    pixelReducer,
    googleReducer,
    webhookReducer,
    smsReducer
})

export default rootReducer;